<template>
<v-container fill-height justify-center align-center >
  <!-- <v-layout row > -->
    <v-flex xs12 sm5 md4 lg3>
      <v-card class="mt-0 pt-0">
          <v-card-title class="blue darken-1">
            <h4 style="color:white">BankPDF-CRM 2.0</h4>
          </v-card-title>
          <v-card-text>
            Для входа в систему отправьте код авторизации телеграм боту @bankpdfbot:<br><br>
            <div align="center" style="font-size: 30px"><b> {{ authcode }}</b></div>
        </v-card-text>
      </v-card>
    </v-flex>
  <!-- </v-layout> -->
  </v-container>
</template>
<script>
import auth from '../utils/auth'
import { mapState } from "vuex";

export default {
  data () {
    return {
      authcode: '',
      pass: 'password',
      error: false,
      text: ''
    }
  },
  methods: {
  },
  computed: {
    ...mapState(
      "user", {
          user: "user"
        },
    ),
  },
  mounted () {
    const tokenMatch = window.location.href.match(/token%3D(.+)$/);
    const cb = (loggedIn, err) => {
          if (err) {
            console.log('login', err)
            this.error = true
            this.text = err
          } else if (loggedIn === false) {
            console.log('login', loggedIn)
            this.error = true
            this.text = 'Bad login information'
          } else {
            console.log(this.$route)
            this.$router.push('/')
            location.reload()
          }
        }

    if (tokenMatch){
      const token = tokenMatch[1];
      setTimeout(() => {
        console.log(JSON.stringify(this.user));
        if (!this.user  || typeof this.user.user_id === "undefined"){
          auth.login(token, 'auth/ext-token', cb)
        }
      }, 1000);
    } else {
      let authcode = Math.floor(Math.random() * 9000 + 1000);
      let r1 = Math.floor(authcode / 1000);
      let r2 = Math.floor(authcode / 100) - r1 * 10;
      let r3 = Math.floor(authcode / 10) - r1 * 100 - r2 * 10;
      let r4 = authcode - r1 * 1000 - r2 * 100 - r3 * 10;
      this.authcode = authcode * 100 + (r1 + r2 + r3 + r4 + 1);
      setInterval(() => {
        console.log(JSON.stringify(this.user));
        if (!this.user  || typeof this.user.user_id === "undefined"){
          auth.login(this.authcode, 'auth/token', cb)
        }
      }, 2000);
    }
  },
}
</script>




// WEBPACK FOOTER //
// Login.vue?72e08faa